import { useState } from "react";

import type JoinSession from "@mpa/toolbox/models/JoinSession";

import LightPageLayout from "../../../components/Page/LightPageLayout";
import PageHeader from "../../../components/Page/PageHeader";
import Stepper from "../../../components/Stepper";
import Step from "../../../components/Stepper/Step";
import CodeStep from "./CodeStep";
import DoneStep from "./DoneStep";
import ExplanationStep from "./ExplanationStep";

export default function InviteMemberPage() {
    const [session, setSession] = useState<JoinSession | null>(null);
    return (
        <LightPageLayout>
            <PageHeader title="Ajouter un membre" />
            <Stepper>
                <Step label="Explication">
                    <ExplanationStep onCreated={setSession} />
                </Step>
                <Step label="Code">{session ? <CodeStep session={session} /> : null}</Step>
                <Step label="Fin">
                    <DoneStep />
                </Step>
            </Stepper>
        </LightPageLayout>
    );
}
